import { Box, useTheme } from "@mui/system";
import GlobalSearchActionView from "./GlobalSearchActionView";
import Typography from '@mui/material/Typography'
import { useNavigate } from "react-router-dom";
import arrowBackSvg from "../../assets/common/arrow-back.svg";
import { useEffect, useState } from "react";
import { CircularProgress } from "@mui/material";

const GlobalSearchActionPage = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const storedActionData = JSON.parse(sessionStorage.getItem('formattedSearchData') || '{}');
  const search = storedActionData?.search || null;
  const actionItemsCount = storedActionData?.actionItemsCount || null;
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(storedActionData);

  interface ActionItem {
    id: string;

  }

  const handleBack = () => {
    const previousPage = sessionStorage.getItem('previousPage');
    if (previousPage) {
      navigate('/tasks/all-tasks');
    } else {

      navigate('/home');
    }
  };

  useEffect(() => {
    const actionItemUpdated = JSON.parse(sessionStorage.getItem("actionItemUpdated") || "false");
    const updateDataListener = () => {
      updateData();
    };

    window.addEventListener('actionItemUpdated', updateDataListener);

    if (actionItemUpdated) {
      updateData();
    } else {
      setLoading(false);
      setData(storedActionData);
    }

    return () => {
      window.removeEventListener('actionItemUpdated', updateDataListener);
    };
  }, []);

  const updateData = () => {
    setLoading(true);

    const storedSearchResults = JSON.parse(sessionStorage.getItem("globalSearchResults") || "[]");
    const storedActionItems = storedActionData?.data?.data?.action_items || [];
    const globalSearchActionItems = storedSearchResults?.data?.data?.action_items || [];

    const storedActionItemIds = storedActionItems.map((item: ActionItem) => item.id);
    const filteredActionItems = globalSearchActionItems.filter((item: ActionItem) =>
      storedActionItemIds.includes(item.id)
    );

    const updatedData = {
      ...storedActionData,
      data: {
        data: {
          meetings: storedSearchResults?.data?.data?.meetings || [],
          action_items: filteredActionItems,
        },
      },
      actionItemsCount: filteredActionItems.length,
    };

    setData(updatedData);
    sessionStorage.setItem('actionItemUpdated', JSON.stringify(false));
    setLoading(false);
  };

  return (
    <Box className="meetingsContent w-full">
      <Box
        sx={{
          height: "100%",
          padding: "15px",
          [theme.breakpoints.down("lg")]: {
            padding: "10px",
          },
          border: `2px solid ${theme.palette.secondary.main}`,
          borderRadius: "22px",
          background: "#FFFFFF",
        }}
      >
        <Box className="flex flex-row justify-start items-center gap-2 cursor-pointer"
          onClick={handleBack}>
          <img src={arrowBackSvg} />
          <Typography variant="h3" >{`Tasks search results for - "${search}"`}</Typography>
        </Box>
        <Typography variant="body2" sx={{ display: "flex", justifyContent: "end", marginTop: "-25px", marginRight: "10px" }}>{actionItemsCount} Tasks Found</Typography>
        <Box className="flex flex-col justify-start" sx={{ marginTop: "10px" }}>
          {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
              <CircularProgress />
            </Box>
          ) : (
            <GlobalSearchActionView searchData={data} />
          )}
        </Box>
      </Box>
    </Box>

  );
};
export default GlobalSearchActionPage;